export const FileType = {
  pdf: {
    className: 'file-pdf-o',
    color: '#B7101C'
  },
  png: {
    className: 'file-image-o',
    color: '#666'
  },
  pptx: {
    className: 'file-powerpoint-o',
    color: '#C84A36'
  },
  xlsx: {
    className: 'file-excel-o',
    color: '#247346'
  },
  xlxs: {
    className: 'file-excel-o',
    color: '#247346'
  },
  csv: {
    className: 'file-excel-o',
    color: '#247346'
  },
  jpg: {
    className: 'file-image-o',
    color: '#666'
  },
  docx: {
    className: 'file-word-o',
    color: '#305497'
  },
  zip: {
    className: 'file-archive-o',
    color: '#D70165'
  },
  ppt: {
    className: 'file-powerpoint-o',
    color: '#C84A36'
  },
  doc: {
    className: 'file-word-o',
    color: '#305497'
  },
  xls: {
    className: 'file-excel-o',
    color: '#247346'
  },
  jpeg: {
    className: 'file-image-o',
    color: '#666'
  },
  rtf: {
    className: 'file-word-o',
    color: '#305497'
  },
  gif: {
    className: 'file-image-o',
    color: '#666'
  },
  tiff: {
    className: 'file-image-o',
    color: '#666'
  },
  ppsx: {
    className: 'file-powerpoint-o',
    color: '#C84A36'
  },
  txt: {
    className: 'file-text-o',
    color: '#666'
  },
  pptm: {
    className: 'file-powerpoint-o',
    color: '#C84A36'
  },
  html: {
    className: 'code',
    color: '#666'
  },
  tmp: {
    className: 'file-o',
    color: '#666'
  },
  mindnode: {
    className: 'file-o',
    color: '#666'
  },
  crdownload: {
    className: 'file-o',
    color: '#666'
  },
  mp3: {
    className: 'file-audio-o',
    color: '#666'
  },
  pzfx: {
    className: 'file-o',
    color: '#666'
  },
  eml: {
    className: 'file-o',
    color: '#666'
  },
};
